import {t} from "@lingui/core/macro";

import {FeedbackType} from "@khan/guide-types";

/**
 * A helper function to generate a feedback form placeholder.
 */
export const feedbackFormPlaceholder = (
    writtenFeedbackType: FeedbackType,
    feedbackIssueType: string,
) => {
    if (writtenFeedbackType === FeedbackType.General) {
        return t`Type message (do NOT share any personal data)`;
    }

    if (feedbackIssueType === "IMAGE_ISSUE") {
        return t`Please describe the issue with the image response. Include a link to the image in Google Drive (or other Cloud service) since we don't actually retain the images you provide as input. (optional) - do NOT share any personal data`;
    }

    if (feedbackIssueType === "DIAGRAM_ISSUE") {
        return t`Please describe the issue with the diagram response - do NOT share any personal data`;
    }

    return t`Please describe the issue (optional) - do NOT share any personal data`;
};
